export const navigationComponents = {
    data: () => ({
        menu: [
            {
                route: '/zesa',
                name: 'ZESA',
                title: 'Electricity',
                subtitle: 'Buy ZESA Tokens',
                icon: 'electricity.svg',
            },
            {
                route: '/airtime',
                title: 'Airtime',
                subtitle: 'Econet & NetOne',
                icon: 'airtime.svg',
            },
            {
                route: '/bundles',
                title: 'Bundles',
                subtitle: 'Econet & NetOne',
                icon: 'bundles.svg',
            },
            {
                route: '/zinara',
                title: 'ZINARA',
                subtitle:'ZBC & Insurance',
                icon: 'zinara.svg',
            },
            {
                title: 'Event Tickets',
                subtitle:'Event tickets',
                route: '/tickets',
                icon: 'tickets.svg',
            },
            {
                title: 'Gift Vouchers',
                subtitle: 'Buy Gift Vouchers',
                route: '/gift-vouchers',
                icon: 'gift-card.svg',
            },
            {
                route: '/telone',
                title: 'TelOne',
                subtitle: 'TelOne bundles',
                icon: 'usd-bundles.svg',
            },
            {
                title: 'Billers and Services',
                subtitle: 'Pay more bills',
                route: '/billers',
                icon: 'billers.svg',
            },
            {
                title: 'Calculators',
                subtitle: 'Magetsi Calculators',
                route: 'calculators/zesa-calculator',
                icon: 'Calculator.png',
            },
            {
                title: 'ZESA Tariffs',
                subtitle: 'View ZESA tariffs',
                route: '/zesa-tariffs',
                icon: 'electricity.svg',
            },
            {
                route: '#',
                title: 'City of Harare',
                subtitle: 'City of Harare',
                icon: 'harare-city.svg',
            },
            {
                route: '#',
                title: 'Insurance',
                subtitle: 'Insurance',
                icon: 'insurance.svg',
            },
            {
                route: '#',
                title: 'School fees',
                subtitle: 'School fees',
                faIcon: 'fas fa-school',
            },
            {
                route: '#',
                title: 'Wifi',
                subtitle: 'Wifi',
                icon: 'wifi.svg',
            },
        ],
        menuOpen: false,
    }),
    computed: {
        showNavigation() {
            return !this.$route.path.startsWith('/auth') &&
                !this.$route.path.startsWith("/business")
        },
        showPartners() {
            return !this.$route.path.startsWith('/auth')
        },
        showFooter() {
            return !this.$route.path.startsWith('/auth')
        }
    },
}
